import React, { useEffect, useState } from 'react'
import { ListItem, List, SwipeableDrawer, Button, Divider } from '@material-ui/core'
import { Link, NavLink, useHistory } from 'react-router-dom'
import './DashboardLayout.css'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import InboxIcon from '@material-ui/icons/MoveToInbox'
import DashboardIcon from '@material-ui/icons/Dashboard'
import { useCustomMediaQuery } from '../../../common/components'
import GavelIcon from '@material-ui/icons/Gavel'
import StarsIcon from '@material-ui/icons/Stars'
import PaymentIcon from '@material-ui/icons/Payment'
import Pageview from '@material-ui/icons/Pageview'
import PropTypes from 'prop-types'
import NotificationsActiveRoundedIcon from '@material-ui/icons/NotificationsActiveRounded'
import ContactsRoundedIcon from '@material-ui/icons/ContactsRounded'
import HighlightOffRoundedIcon from '@material-ui/icons/HighlightOffRounded'
import { Ballot, Archive } from '@material-ui/icons'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles({
    list: {
        width: 250,
    },
    fullList: {
        width: 'auto',
    },
})

function DashboardLayout(props) {
    const classes = useStyles()
    const [state, setState] = React.useState({
        left: false,
    })

    const { t } = useTranslation()

    const [user, setUser] = React.useState(
        localStorage.getItem('coachUser') ? JSON.parse(localStorage.getItem('coachUser')) : {},
    )
    useEffect(() => {
        setUser(
            localStorage.getItem('coachUser') ? JSON.parse(localStorage.getItem('coachUser')) : {},
        )
    }, [])
    const getInitials = (fullName) => {
        if (!fullName) return ''

        const names = fullName.trim().split(' ')
        const firstInitial = names[0]?.charAt(0).toUpperCase() || ''
        const lastInitial = names.length > 1 ? names[names.length - 1].charAt(0).toUpperCase() : ''

        return firstInitial + lastInitial
    }
    const toggleDrawer = (anchor, open) => (event) => {
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return
        }

        setState({ ...state, [anchor]: open })
    }
    const pathname = window.location.pathname
    const list = (anchor) => (
        <div
            className={clsx(
                classes.list,
                {
                    [classes.fullList]: anchor === 'top' || anchor === 'bottom',
                },
                'commonDashNavSlider',
            )}
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <div className="SideLogo">
                <Link to="/">
                    <img src="/assets/svg/carzaar-logo.svg" className="headerLogo" alt="carzaar" />
                </Link>
                {/* <Button onClick={toggleDrawer(anchor, false)}>
                    <HighlightOffRoundedIcon fontSize="large" color="secondary" object />
                </Button> */}
            </div>
            <Divider />

            <h4>{t('dashboard')}</h4>
            <div className="userName"> {getInitials(`${user?.first_name} ${user?.last_name}`)}</div>
            <hr style={{ backgroundColor: 'white' }} />
            <List>
                {user?.role != 4 && (
                    <ListItem button>
                        <NavLink
                            className="dashboardNav"
                            to={
                                user?.role == 0
                                    ? '/dashboard/buyer/myauction'
                                    : '/dashboard/seller/myauction'
                            }
                            activeClassName="active"
                        >
                            <ListItemIcon>
                                <GavelIcon />
                                {t('my_purchases')}
                            </ListItemIcon>
                        </NavLink>
                    </ListItem>
                )}

                <ListItem button>
                    <NavLink
                        className="dashboardNav"
                        to="/dashboard/seller/mylots"
                        activeClassName="active"
                    >
                        <ListItemIcon>
                            <Ballot />
                            {t('my_lots')}
                        </ListItemIcon>
                    </NavLink>
                </ListItem>
                {user?.role != 4 && (
                    <ListItem button>
                        <NavLink
                            to={
                                user?.role == 0
                                    ? '/dashboard/buyer/watchlist'
                                    : '/dashboard/seller/watchlist'
                            }
                            className="dashboardNav"
                            activeClassName="active"
                        >
                            <ListItemIcon>
                                <StarsIcon />
                                {t('my_watchlist')}
                            </ListItemIcon>
                        </NavLink>
                    </ListItem>
                )}
                <ListItem button>
                    <NavLink
                        to="/dashboard/buyer/payment"
                        className="dashboardNav"
                        activeClassName="active"
                    >
                        <ListItemIcon>
                            <PaymentIcon />
                            {t('my_payments')}
                        </ListItemIcon>
                    </NavLink>
                </ListItem>
                <ListItem button>
                    <NavLink
                        to="/dashboard/buyer/notification"
                        className="dashboardNav"
                        activeClassName="active"
                    >
                        <ListItemIcon>
                            <NotificationsActiveRoundedIcon />
                            {t('my_notification')}
                        </ListItemIcon>
                    </NavLink>
                </ListItem>
                <ListItem button>
                    <NavLink
                        to="/dashboard/buyer/profile"
                        className="dashboardNav"
                        activeClassName="active"
                    >
                        <ListItemIcon>
                            <ContactsRoundedIcon />
                            {t('my_profile')}
                        </ListItemIcon>
                    </NavLink>
                </ListItem>
            </List>
        </div>
    )

    return (
        <div className="position-relative">
            <div
                // className="dashSwipeableDrawer"
                className={
                    useCustomMediaQuery('(max-width:900px)') ? 'dashSwipeableDrawer' : 'd-none'
                }
            >
                {['left'].map((anchor) => (
                    <React.Fragment key={anchor}>
                        <Button onClick={toggleDrawer(anchor, true)}>
                            <DashboardIcon />
                        </Button>
                        <SwipeableDrawer
                            anchor={anchor}
                            open={state[anchor]}
                            onClose={toggleDrawer(anchor, false)}
                            onOpen={toggleDrawer(anchor, true)}
                        >
                            {list(anchor)}
                        </SwipeableDrawer>
                    </React.Fragment>
                ))}
            </div>
            <div className="dashboardLayout customContainer">
                <div className="dashboardLt">
                    <h4>{t('dashboard')}</h4>
                    <div className="userName">
                        {' '}
                        {getInitials(`${user?.first_name} ${user?.last_name}`)}
                    </div>
                    <hr style={{ backgroundColor: 'white' }} />
                    <ul>
                        {user?.role != 4 && user?.role != 1 && (
                            <ListItem button>
                                <NavLink
                                    to={'/dashboard/buyer/myauction'}
                                    className="dashboardNav"
                                    activeClassName="active"
                                >
                                    <GavelIcon />
                                    {t('my_purchases')}
                                </NavLink>
                            </ListItem>
                        )}

                        <ListItem button>
                            <NavLink
                                to={`${
                                    user?.role == 4
                                        ? '/dashboard/ambassador/mylots'
                                        : user?.role == 0
                                        ? '/dashboard/buyer/mylots'
                                        : '/dashboard/seller/mylots'
                                }`}
                                className="dashboardNav"
                                activeClassName="active"
                            >
                                <Ballot />
                                {t('my_lots')}
                            </NavLink>
                        </ListItem>
                        {user?.role == 4 && (
                            <ListItem button>
                                <NavLink
                                    to={'/dashboard/ambassador/mylots?archived=1'}
                                    className="dashboardNav"
                                    activeClassName="active"
                                >
                                    <Archive />
                                    {t('archived')}
                                </NavLink>
                            </ListItem>
                        )}
                        {user?.role != 4 && (
                            <ListItem button>
                                <NavLink
                                    to={
                                        user?.role == 0
                                            ? '/dashboard/buyer/watchlist'
                                            : '/dashboard/seller/watchlist'
                                    }
                                    className="dashboardNav"
                                    activeClassName="active"
                                >
                                    <StarsIcon />
                                    {t('my_watchlist')}
                                </NavLink>
                            </ListItem>
                        )}
                        {/* <ListItem button>
                            <NavLink
                                to="/dashboard/buyer/payment"
                                className="dashboardNav"
                                activeClassName="active"
                            >
                                <PaymentIcon />
                                My Payments
                            </NavLink>
                        </ListItem> */}
                        <ListItem button>
                            <NavLink
                                to={`${
                                    user?.role == 4
                                        ? '/dashboard/ambassador/notification'
                                        : user?.role == 0
                                        ? '/dashboard/buyer/notification'
                                        : '/dashboard/seller/notification'
                                }`}
                                className="dashboardNav"
                                activeClassName="active"
                            >
                                <NotificationsActiveRoundedIcon />
                                {t('my_notification')}
                            </NavLink>
                        </ListItem>
                        <ListItem button>
                            <NavLink
                                to={`${
                                    user?.role == 4
                                        ? '/dashboard/ambassador/profile'
                                        : user?.role == 0
                                        ? '/dashboard/buyer/profile'
                                        : '/dashboard/seller/profile'
                                }`}
                                className="dashboardNav"
                                activeClassName="active"
                            >
                                <ContactsRoundedIcon />
                                {t('my_profile')}
                            </NavLink>
                        </ListItem>
                    </ul>
                </div>
                <div className="dashboardRt">{props.children}</div>
            </div>
        </div>
    )
}

export default DashboardLayout
